var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2140",
    "data-name": "Group 2140",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.055,
    height: 11.054,
    viewBox: "0 0 11.055 11.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M-400.684,173.192h-3.68a.543.543,0,0,1-.568-.4.712.712,0,0,1-.02-.192c0-2.38.005-4.759,0-7.139a3.32,3.32,0,0,1,2.627-3.251,3.647,3.647,0,0,1,.732-.069c1.447-.006,2.893.008,4.34-.006a3.319,3.319,0,0,1,3.28,2.624,3.624,3.624,0,0,1,.07.719c.007,1.455-.006,2.911.006,4.366a3.316,3.316,0,0,1-2.62,3.269,3.952,3.952,0,0,1-.77.072C-398.421,173.2-399.553,173.192-400.684,173.192Zm.7-3.11,3.4-3.4-.788-.787-2.634,2.635-1.232-1.234-.761.763Z",
    transform: "translate(404.955 -162.139)",
    fill: "#039511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M-288.93,311.429l-2.019-2.02.761-.763,1.232,1.234,2.634-2.635.788.787Z",
    transform: "translate(293.904 -303.485)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.9660bd9910d6bd78dbcc8d6b82642c04.svg";
export { ForwardRef as ReactComponent };